import { InputAdornment, TextField } from "@material-ui/core"
import { Search } from "@material-ui/icons"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { useDebounce } from "use-lodash-debounce"
import Box from "../Common/Box"
import useStyles from "./styles"

const DebouncedSearch = ({ placeholder, onChange, searchInputRef = {} }) => {
  const classes = useStyles()

  const [valueHolder, setValueHolder] = useState("")
  const debouncedSearch = useDebounce(valueHolder, 250)

  useEffect(() => {
    onChange(valueHolder)
  }, [debouncedSearch])

  return (
    <Box>
      <TextField
        inputRef={searchInputRef}
        placeholder={placeholder}
        className={classes.search}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onChange(valueHolder)
          }
        }}
        onChange={(e) => setValueHolder(e.target.value)}
        InputProps={{
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position="start" style={{ marginLeft: "10px" }}>
              <Search className={classes.searchIcon} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  )
}
DebouncedSearch.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  searchInputRef: PropTypes.object,
}
export default DebouncedSearch
